/*
    코드	설명
CJGLS	CJ대한통운	
HYUNDAI	롯데택배	
HANJIN	한진택배	
KGB	로젠택배	
EPOST	우체국택배	
MTINTER	(주)엠티인터내셔널	
1004HOME	1004HOME	
TWOFASTEXPRESS	2FAST익스프레스	
ACE	ACEexpress	
ACIEXPRESS	ACI	
ADCAIR	ADC항운택배	
AIRWAY	AIRWAY익스프레스	
APEX	APEX	
ARAMEX	ARAMEX	
ARGO	ARGO	
AIRBOY	AirboyExpress	
KOREXG	CJ대한통운(국제택배)	
CUPARCEL	CU편의점택배	
CWAYEXPRESS	CwayExpress	
DHL	DHL	
DHLDE	DHL(독일)	
DHLGLOBALMAIL	DHLGlobalMail	
DPD	DPD	
ECMSEXPRESS	ECMSExpress	
EFS	EFS	
EMS	EMS	
EZUSA	EZUSA	
EUROPARCEL	EuroParcel	
FEDEX	FEDEX	
GOP	GOP당일택배	
GOS	GOS당일택배	
GPSLOGIX	GPSLOGIX	
GSFRESH	GSFresh	
GSIEXPRESS	GSI익스프레스	
GSMNTON	GSMNTON	
GSPOSTBOX	GSPostbox퀵	
CVSNET	GSPostbox택배	
GS더프레시	GSTHEFRESH	
GTSLOGIS	GTS로지스	
HYBRID	HI택배	
HY	HY	
IK	IK물류	
KGLNET	KGL네트웍스	
KT	KT EXPRESS	
LGE	LG전자배송센터	
LTL	LTL	
NDEXKOREA	NDEX KOREA	
SBGLS	SBGLS	
SFEX	SFexpress	
SLX	SLX택배	
SSG	SSG	
TNT	TNT	
LOGISPARTNER	UFO로지스	
UPS	UPS	
USPS	USPS	
WIZWA	WIZWA	
YJSWORLD	YJS글로벌	
YJS	YJS글로벌(영국)	
YUNDA	YUNDAEXPRESS	
IPARCEL	i-parcel	
KY	건영복합물류	
KUNYOUNG	건영택배	
KDEXP	경동택배	
KIN	경인택배	
KORYO	고려택배	
GDSP	골드스넵스	
KOKUSAI	국제익스프레스	
GOODTOLUCK	굿투럭	
NAEUN	나은물류	
NOGOK	노곡물류	
NONGHYUP	농협택배	
HANAROMART	농협하나로마트	
DAELIM	대림통운	
DAESIN	대신택배	
DAEWOON	대운글로벌	
THEBAO	더바오	
DODOFLEX	도도플렉스	
DONGGANG	동강물류	
DONGJIN	동진특송	
CHAINLOGIS	두발히어로당일택배	
DRABBIT	딜리래빗	
JMNP	딜리박스	
ONEDAYLOGIS	라스트마일	
LINEEXP	라인익스프레스	
ROADSUNEXPRESS	로드썬익스프레스	
LOGISVALLEY	로지스밸리	
POOLATHOME	로지스올홈케어(풀앳홈)	
LOTOS	로토스	
HLCGLOBAL	롯데글로벌로지스(국제택배)	
LOTTECHILSUNG	롯데칠성	
MDLOGIS	모든로지스(SLO)	
DASONG	물류대장	
BABABA	바바바로지스	
BANPOOM	반품구조대	
VALEX	발렉스	
SHIPNERGY	배송하기좋은날	
PANTOS	범한판토스	
VROONG	부릉	
BRIDGE	브릿지로지스	
EKDP	삼다수가정배송	
SELC	삼성전자물류	
SEORIM	서림물류	
SWGEXP	성원글로벌	
SUNGHUN	성훈물류	
SEBANG	세방택배	
SMARTLOGIS	스마트로지스	
SPARKLE	스파클직배송	
SPASYS1	스페이시스원	
CRLX	시알로지텍	
ANYTRACK	애니트랙	
ABOUTPET	어바웃펫	
ESTHER	에스더쉬핑	
VENDORPIA	에이스물류	
ACTCORE	에이씨티앤코아	
HKHOLDINGS	에이치케이홀딩스	
NTLPS	엔티엘피스	
LSLOGIS	엘로지스	
TODAYPICKUP	카카오T당일배송	
RUSH	오늘회러쉬	
ALLIN	올인닷컴	
ALLTAKOREA	올타코리아	
WIDETECH	와이드테크	
YONGMA	용마로지스	
DCOMMERCE	우리동네커머스	
WEVILL	우리동네택배	
HONAM	우리택배	
WOORIHB	우리한방택배	
WOOJIN	우진인터로지스	
REGISTPOST	우편등기	
WOONGJI	웅지익스프레스	
WARPEX	워펙스	
WINION	위니온로지스	
WIHTYOU	위드유당일택배	
WEMOVE	위무브	
UFREIGHT	유프레이트코리아	
EUNHA	은하쉬핑	
INNOS	이노스(올인닷컴)	
EMARTEVERYDAY	이마트에브리데이	
ESTLA	이스트라	
ETOMARS	이투마스	
GENERALPOST	일반우편	
ILSHIN	일신모닝택배	
ILYANG	일양로지스	
GNETWORK	자이언트	
ZENIEL	제니엘시스템	
JLOGIST	제이로지스트	
GENIEGO	지니고당일특급	
GDAKOREA	지디에이코리아	
GHSPEED	지에이치스피드	
JIKGUMOON	직구문	
CHUNIL	천일택배	
CHOROC	초록마을	
CHOROCMAEUL	초록마을(네이버직연동)	
COSHIP	캐나다쉬핑	
KJT	케이제이티	
QRUN	큐런	
CUBEFLOW	큐브플로우	
QXPRESS	큐익스프레스	
HEREWEGO	탱고앤고	
TOMATO	토마토앱	
TODAY	투데이	
TSG	티에스지로지스	
TEAMFRESH	팀프레시	
PATEK	파테크해운상공	
XINPATEK	파테크해운항공	
PANASIA	판월드로지스틱	
PANSTAR	팬스타국제특송(PIEX)	
FOREVER	퍼레버택배	
PULMUONE	풀무원(로지스밸리)	
FREDIT	프레딧	
FRESHMATES	프레시메이트	
FRESH	프레시솔루션	
PINGPONG	핑퐁	
HOWSER	하우저	
HIVECITY	하이브시티	
HANDALUM	한달음택배	
HANDEX	한덱스	
HANMI	한미포스트	
HANSSEM	한샘	
HANWOORI	한우리물류	
HPL	한의사랑택배	
HDEXP	합동택배	
HERWUZUG	허우적	
GLOVIS	현대글로비스	
HOMEINNO	홈이노베이션로지스	
HOMEPICKTODAY	홈픽오늘도착	
HOMEPICK	홈픽택배	
HOMEPLUSDELIVERY	홈플러스	
HOMEPLUSEXPRESS	홈플러스익스프레스	
CARGOPLEASE	화물을부탁해	
HWATONG	화통	
CH1	해외기타택배	
LETUS	레터스	
*/
export const deliveryCompanyCodes = [
    { code: 'CJGLS', name: 'CJ대한통운' },
    { code: 'CHUNIL', name: '천일택배' },
    { code: 'KDEXP', name: '경동택배' },
    { code: 'HYUNDAI', name: '롯데택배' },
    { code: 'HANJIN', name: '한진택배' },
    { code: 'KGB', name: '로젠택배' },
    { code: 'EPOST', name: '우체국택배' },
    { code: 'MTINTER', name: '(주)엠티인터내셔널' },
    { code: '1004HOME', name: '1004HOME' },
    { code: 'TWOFASTEXPRESS', name: '2FAST익스프레스' },
    { code: 'ACE', name: 'ACEexpress' },
    { code: 'ACIEXPRESS', name: 'ACI' },
    { code: 'ADCAIR', name: 'ADC항운택배' },
    { code: 'AIRWAY', name: 'AIRWAY익스프레스' },
    { code: 'APEX', name: 'APEX' },
    { code: 'ARAMEX', name: 'ARAMEX' },
    { code: 'ARGO', name: 'ARGO' },
    { code: 'AIRBOY', name: 'AirboyExpress' },
    { code: 'KOREXG', name: 'CJ대한통운(국제택배)' },
    { code: 'CUPARCEL', name: 'CU편의점택배' },
    { code: 'CWAYEXPRESS', name: 'CwayExpress' },
    { code: 'DHL', name: 'DHL' },
    { code: 'DHLDE', name: 'DHL(독일)' },
    { code: 'DHLGLOBALMAIL', name: 'DHLGlobalMail' },
    { code: 'DPD', name: 'DPD' },
    { code: 'ECMSEXPRESS', name: 'ECMSExpress' },
    { code: 'EFS', name: 'EFS' },
    { code: 'EMS', name: 'EMS' },
    { code: 'EZUSA', name: 'EZUSA' },
    { code: 'EUROPARCEL', name: 'EuroParcel' },
    { code: 'FEDEX', name: 'FEDEX' },
    { code: 'GOP', name: 'GOP당일택배' },
    { code: 'GOS', name: 'GOS당일택배' },
    { code: 'GPSLOGIX', name: 'GPSLOGIX' },
    { code: 'GSFRESH', name: 'GSFresh' },
    { code: 'GSIEXPRESS', name: 'GSI익스프레스' },
    { code: 'GSMNTON', name: 'GSMNTON' },
    { code: 'GSPOSTBOX', name: 'GSPostbox퀵' },
    { code: 'CVSNET', name: 'GSPostbox택배' },
    { code: 'GS더프레시', name: 'GSTHEFRESH' },
    { code: 'GTSLOGIS', name: 'GTS로지스' },
    { code: 'HYBRID', name: 'HI택배' },
    { code: 'HY', name: 'HY' },
    { code: 'IK', name: 'IK물류' },
    { code: 'KGLNET', name: 'KGL네트웍스' },
    { code: 'KT', name: 'KT EXPRESS' },
    { code: 'LGE', name: 'LG전자배송센터' },
    { code: 'LTL', name: 'LTL' },
    { code: 'NDEXKOREA', name: 'NDEX KOREA' },
    { code: 'SBGLS', name: 'SBGLS' },
    { code: 'SFEX', name: 'SFexpress' },
    { code: 'SLX', name: 'SLX택배' },
    { code: 'SSG', name: 'SSG' },
    { code: 'TNT', name: 'TNT' },
    { code: 'LOGISPARTNER', name: 'UFO로지스' },
    { code: 'UPS', name: 'UPS' },
    { code: 'USPS', name: 'USPS' },
    { code: 'WIZWA', name: 'WIZWA' },
    { code: 'YJSWORLD', name: 'YJS글로벌' },
    { code: 'YJS', name: 'YJS글로벌(영국)' },
    { code: 'YUNDA', name: 'YUNDAEXPRESS' },
    { code: 'IPARCEL', name: 'i-parcel' },
    { code: 'KY', name: '건영복합물류' },
    { code: 'KUNYOUNG', name: '건영택배' },
    { code: 'KIN', name: '경인택배' },
    { code: 'KORYO', name: '고려택배' },
    { code: 'GDSP', name: '골드스넵스' },
    { code: 'KOKUSAI', name: '국제익스프레스' },
    { code: 'GOODTOLUCK', name: '굿투럭' },
    { code: 'NAEUN', name: '나은물류' },
    { code: 'NOGOK', name: '노곡물류' },
    { code: 'NONGHYUP', name: '농협택배' },
    { code: 'HANAROMART', name: '농협하나로마트' },
    { code: 'DAELIM', name: '대림통운' },
    { code: 'DAESIN', name: '대신택배' },
    { code: 'DAEWOON', name: '대운글로벌' },
    { code: 'THEBAO', name: '더바오' },
    { code: 'DODOFLEX', name: '도도플렉스' },
    { code: 'DONGGANG', name: '동강물류' },
    { code: 'DONGJIN', name: '동진특송' },
    { code: 'CHAINLOGIS', name: '두발히어로당일택배' },
    { code: 'DRABBIT', name: '딜리래빗' },
    { code: 'JMNP', name: '딜리박스' },
    { code: 'ONEDAYLOGIS', name: '라스트마일' },
    { code: 'LINEEXP', name: '라인익스프레스' },
    { code: 'ROADSUNEXPRESS', name: '로드썬익스프레스' },
    { code: 'LOGISVALLEY', name: '로지스밸리' },
    { code: 'POOLATHOME', name: '로지스올홈케어(풀앳홈)' },
    { code: 'LOTOS', name: '로토스' },
    { code: 'HLCGLOBAL', name: '롯데글로벌로지스(국제택배)' },
    { code: 'LOTTECHILSUNG', name: '롯데칠성' },
    { code: 'MDLOGIS', name: '모든로지스(SLO)' },
    { code: 'DASONG', name: '물류대장' },
    { code: 'BABABA', name: '바바바로지스' },
    { code: 'BANPOOM', name: '반품구조대' },
    { code: 'VALEX', name: '발렉스' },
    { code: 'SHIPNERGY', name: '배송하기좋은날' },
    { code: 'PANTOS', name: '범한판토스' },
    { code: 'VROONG', name: '부릉' },
    { code: 'BRIDGE', name: '브릿지로지스' },
    { code: 'EKDP', name: '삼다수가정배송' },
    { code: 'SELC', name: '삼성전자물류' },
    { code: 'SEORIM', name: '서림물류' },
    { code: 'SWGEXP', name: '성원글로벌' },
    { code: 'SUNGHUN', name: '성훈물류' },
    { code: 'SEBANG', name: '세방택배' },
    { code: 'SMARTLOGIS', name: '스마트로지스' },
    { code: 'SPARKLE', name: '스파클직배송' },
    { code: 'SPASYS1', name: '스페이시스원' },
    { code: 'CRLX', name: '시알로지텍' },
    { code: 'ANYTRACK', name: '애니트랙' },
    { code: 'ABOUTPET', name: '어바웃펫' },
    { code: 'ESTHER', name: '에스더쉬핑' },
    { code: 'VENDORPIA', name: '에이스물류' },
    { code: 'ACTCORE', name: '에이씨티앤코아' },
    { code: 'HKHOLDINGS', name: '에이치케이홀딩스' },
    { code: 'NTLPS', name: '엔티엘피스' },
    { code: 'LSLOGIS', name: '엘로지스' },
    { code: 'TODAYPICKUP', name: '카카오T당일배송' },
    { code: 'RUSH', name: '오늘회러쉬' },
    { code: 'ALLIN', name: '올인닷컴' },
    { code: 'ALLTAKOREA', name: '올타코리아' },
    { code: 'WIDETECH', name: '와이드테크' },
    { code: 'YONGMA', name: '용마로지스' },
    { code: 'DCOMMERCE', name: '우리동네커머스' },
    { code: 'WEVILL', name: '우리동네택배' },
    { code: 'HONAM', name: '우리택배' },
    { code: 'WOORIHB', name: '우리한방택배' },
    { code: 'WOOJIN', name: '우진인터로지스' },
    { code: 'REGISTPOST', name: '우편등기' },
    { code: 'WOONGJI', name: '웅지익스프레스' },
    { code: 'WARPEX', name: '워펙스' },
    { code: 'WINION', name: '위니온로지스' },
    { code: 'WIHTYOU', name: '위드유당일택배' },
    { code: 'WEMOVE', name: '위무브' },
    { code: 'UFREIGHT', name: '유프레이트코리아' },
    { code: 'EUNHA', name: '은하쉬핑' },
    { code: 'INNOS', name: '이노스(올인닷컴)' },
    { code: 'EMARTEVERYDAY', name: '이마트에브리데이' },
    { code: 'ESTLA', name: '이스트라' },
    { code: 'ETOMARS', name: '이투마스' },
    { code: 'GENERALPOST', name: '일반우편' },
    { code: 'ILSHIN', name: '일신모닝택배' },
    { code: 'ILYANG', name: '일양로지스' },
    { code: 'GNETWORK', name: '자이언트' },
    { code: 'ZENIEL', name: '제니엘시스템' },
    { code: 'JLOGIST', name: '제이로지스트' },
    { code: 'GENIEGO', name: '지니고당일특급' },
    { code: 'GDAKOREA', name: '지디에이코리아' },
    { code: 'GHSPEED', name: '지에이치스피드' },
    { code: 'JIKGUMOON', name: '직구문' },
    { code: 'CHOROC', name: '초록마을' },
    { code: 'CHOROCMAEUL', name: '초록마을(네이버직연동)' },
    { code: 'COSHIP', name: '캐나다쉬핑' },
    { code: 'KJT', name: '케이제이티' },
    { code: 'QRUN', name: '큐런' },
    { code: 'CUBEFLOW', name: '큐브플로우' },
    { code: 'QXPRESS', name: '큐익스프레스' },
    { code: 'HEREWEGO', name: '탱고앤고' },
    { code: 'TOMATO', name: '토마토앱' },
    { code: 'TODAY', name: '투데이' },
    { code: 'TSG', name: '티에스지로지스' },
    { code: 'TEAMFRESH', name: '팀프레시' },
    { code: 'PATEK', name: '파테크해운상공' },
    { code: 'XINPATEK', name: '파테크해운항공' },
    { code: 'PANASIA', name: '판월드로지스틱' },
    { code: 'PANSTAR', name: '팬스타국제특송(PIEX)' },
    { code: 'FOREVER', name: '퍼레버택배' },
    { code: 'PULMUONE', name: '풀무원(로지스밸리)' },
    { code: 'FREDIT', name: '프레딧' },
    { code: 'FRESHMATES', name: '프레시메이트' },
    { code: 'FRESH', name: '프레시솔루션' },
    { code: 'PINGPONG', name: '핑퐁' },
    { code: 'HOWSER', name: '하우저' },
    { code: 'HIVECITY', name: '하이브시티' },
    { code: 'HANDALUM', name: '한달음택배' },
    { code: 'HANDEX', name: '한덱스' },
    { code: 'HANMI', name: '한미포스트' },
    { code: 'HANSSEM', name: '한샘' },
    { code: 'HANWOORI', name: '한우리물류' },
    { code: 'HPL', name: '한의사랑택배' },
    { code: 'HDEXP', name: '합동택배' },
    { code: 'HERWUZUG', name: '허우적' },
    { code: 'GLOVIS', name: '현대글로비스' },
    { code: 'HOMEINNO', name: '홈이노베이션로지스' },
    { code: 'HOMEPICKTODAY', name: '홈픽오늘도착' },
    { code: 'HOMEPICK', name: '홈픽택배' },
    { code: 'HOMEPLUSDELIVERY', name: '홈플러스' },
    { code: 'HOMEPLUSEXPRESS', name: '홈플러스익스프레스' },
    { code: 'CARGOPLEASE', name: '화물을부탁해' },
    { code: 'HWATONG', name: '화통' },
    { code: 'CH1', name: '해외기타택배' },
    { code: 'LETUS', name: '레터스' }
];
